import styled from '@emotion/styled'
import theme from '@utils/theme'

export const StyleImageGrid = styled.div`
  display: flex;
  justify-content: center;
`
export const StyleImageWrapper = styled.div`
  width: 110px;
  height: 110px;
  border-radius: 100vh;
`
export const StyleImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 100vh;
`
export const StylePermissionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-content: center;
  row-gap: 20px;
  column-gap: 50px;
`
export const StylePermission = styled.div<{ selected?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 10px;
  border: 1px solid
    ${({ selected, theme }: any) =>
      selected ? theme.colors.primary : theme.colors.borderColor};
  background: ${({ selected }) =>
    selected ? theme.colors.primaryLight : 'transparent'};
  border-radius: 10px;
  padding: 12px;
  svg {
    stroke: ${({ selected, theme }: any) =>
      selected ? theme.colors.primary : ''};
    stroke-width: 0.8;
  }
`
